import { Button } from '@/app/components/Button'
import { TRACKING_LOCATIONS } from '@/app/utils/analytics'
import { cn } from '@/app/utils/style'
import { slugify } from '@/app/utils/text'
import type { FaqQueryResult } from '@/sanity.types'

type FAQNavProps = {
  categories: NonNullable<FaqQueryResult>['categories']
  selectedCategory: string
  onCategoryChange: (slug: string) => void
}

export function FAQNav({ categories, selectedCategory, onCategoryChange }: FAQNavProps) {
  const allQuestionsButton = {
    _type: 'button' as const,
    variant: 'tertiary' as const,
    size: 'sm' as const,
    iconPlacement: 'left' as const,
    icon: {
      _type: 'icon' as const,
      provider: 'fontawesome' as const,
      name: 'faCircleQuestion',
      style: 'solid' as const,
    },
  }

  return (
    <div className="flex flex-col gap-lg">
      <Button
        button={allQuestionsButton}
        tracking={{ location: TRACKING_LOCATIONS.PAGE_CONTENT }}
        onClick={() => onCategoryChange('all')}
        className={cn(
          'justify-start cursor-pointer',
          selectedCategory === 'all' &&
            '!text-blue-600 [&_span_span]:[transform:translateY(var(--underline-offset))_scaleX(1)] [&_span_span]:!bg-primary-600',
        )}
      >
        All Questions
      </Button>

      {categories.map((category) => {
        const categoryButton = {
          _type: 'button' as const,
          variant: 'tertiary' as const,
          size: 'sm' as const,
          iconPlacement: 'left' as const,
          icon: category.icon || null,
        }

        const isSelected = selectedCategory === slugify(category.title ?? 'untitled')

        return (
          <Button
            key={category._id}
            button={categoryButton}
            tracking={{ location: TRACKING_LOCATIONS.PAGE_CONTENT }}
            onClick={() => onCategoryChange(slugify(category.title ?? 'untitled'))}
            className={cn(
              'justify-start cursor-pointer',
              isSelected &&
                '!text-blue-600 [&_span_span]:[transform:translateY(var(--underline-offset))_scaleX(1)] [&_span_span]:!bg-primary-600',
            )}
          >
            {category.title}
          </Button>
        )
      })}
    </div>
  )
}
